import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/joy';
import { useAuth } from '../../contexts/AuthContext';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { SiteList } from './SiteList';
import { PageList } from './PageList';
import { PageEditor } from './PageEditor';
import { SiteSettingsEnhanced } from './SiteSettingsEnhanced';
import { OnboardingWizard } from '../../components/cms/onboarding';
import { SetupWizard } from './SetupWizard';
import { CMSDashboard } from './CMSDashboard';
import { DeploymentDashboard } from './DeploymentDashboard';
import { DeploymentWizard } from './DeploymentWizard';
import { DeploymentProgress } from './DeploymentProgress';
import { DeploymentHistory } from './DeploymentHistory';
import { useParams } from 'react-router-dom';

const SiteSettingsWrapper: React.FC = () => {
  const { siteId } = useParams<{ siteId: string }>();
  return <SiteSettingsEnhanced siteId={parseInt(siteId || '0')} />;
};

export const CMSApp: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <Box>Loading...</Box>;
  }

  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="/dashboard" element={<CMSDashboard />} />
        <Route path="/sites/new" element={<OnboardingWizard />} />
        <Route path="/sites/quick-setup" element={<SetupWizard />} />
        <Route path="/sites" element={<SiteList />} />
        <Route path="/sites/:siteId/settings" element={<SiteSettingsWrapper />} />
        <Route path="/sites/:siteId/deploy" element={<DeploymentDashboard />} />
        <Route path="/sites/:siteId/deploy/wizard" element={<DeploymentWizard />} />
        <Route path="/sites/:siteId/deploy/progress/:deploymentId" element={<DeploymentProgress />} />
        <Route path="/sites/:siteId/deploy/history" element={<DeploymentHistory />} />
        <Route path="/sites/:siteId/pages" element={<PageList />} />
        <Route path="/sites/:siteId/pages/new" element={<PageEditor />} />
        <Route path="/sites/:siteId/pages/:pageId" element={<PageEditor />} />
      </Route>
    </Routes>
  );
};